import introBgImg from '~/assets/figma/intro-bg.webp'
import introCurtainImg from '~/assets/figma/intro-curtain.png'
import introSunshineImg from '~/assets/figma/intro-sunshine.webp'
import wheatRightSvg from '~/assets/figma/wheat-right.svg'
import { m } from '~/paraglide/messages'
import { INTRO_LIST_ITEM_COUNT, IntroList } from './intro-list'

export function IntroPage(props: { onStart: () => void }) {
  const handleEnter = () => {
    props.onStart()
  }

  return (
    <main class="relative flex min-h-screen w-full flex-col items-center overflow-hidden bg-[#f5e8d6]">
      <div class="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2">
        <img
          src={introBgImg}
          alt=""
          aria-hidden="true"
          class="h-[870px] w-[1600px] max-w-none animate-intro-rise opacity-0"
        />
      </div>
      <div
        aria-hidden
        class="pointer-events-none absolute left-1/2 top-0 -translate-x-1/2"
        style={{
          '-webkit-mask-image':
            'linear-gradient(to right, transparent 0%, black 18%, black 82%, transparent 100%)',
          'mask-image':
            'linear-gradient(to right, transparent 0%, black 18%, black 82%, transparent 100%)',
        }}
      >
        <div
          class="animate-intro-rise opacity-0"
          style={{ 'animation-delay': '100ms' }}
        >
          <img
            src={introSunshineImg}
            alt=""
            class="h-[1540px] w-[1250px] max-w-none opacity-25 mix-blend-screen"
          />
        </div>
      </div>

      <div class="pointer-events-none absolute left-0 top-0 -scale-x-100">
        <img
          src={introCurtainImg}
          alt=""
          aria-hidden="true"
          class="h-[774px] w-[138px] animate-intro-rise opacity-0"
        />
      </div>
      <img
        src={introCurtainImg}
        alt=""
        aria-hidden="true"
        class="pointer-events-none absolute right-0 top-0 h-[774px] w-[138px] animate-intro-rise opacity-0"
      />

      <div
        aria-hidden
        class="pointer-events-none absolute -inset-x-8 bottom-0 h-[50vh] animate-intro-rise opacity-0 [filter:blur(15.5px)]"
        style={{
          background:
            'radial-gradient(ellipse 75% 60% at 50% 30%, rgba(254,250,237,1) 0%, rgba(224,196,172,1) 100%)',
          '-webkit-mask-image':
            'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.4) 12%, black 35%, black 100%)',
          'mask-image':
            'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.4) 12%, black 35%, black 100%)',
          'animation-delay': '150ms',
        }}
      />

      <div
        class="absolute left-0 right-0 top-[30vh] flex animate-intro-rise items-center justify-center gap-2 opacity-0"
        style={{ 'animation-delay': '300ms' }}
      >
        <img
          src={wheatRightSvg}
          alt=""
          aria-hidden="true"
          class="size-[38px] shrink-0 -scale-x-100"
        />
        <h1
          class="whitespace-pre-line bg-clip-text pb-3 text-center font-display text-[54px] leading-[1.1] text-transparent"
          style={{
            'background-image':
              'radial-gradient(ellipse at 60% 70%, #CC8033 3%, #996026 51%, #66401A 100%)',
          }}
        >
          {m.bakery_intro_hero_title()}
        </h1>
        <img
          src={wheatRightSvg}
          alt=""
          aria-hidden="true"
          class="size-[38px] shrink-0"
        />
      </div>

      <div class="absolute bottom-[120px] left-0 right-0 mx-auto w-full max-w-[360px] px-6">
        <IntroList staggerStartMs={600} />
      </div>

      <div class="absolute bottom-12 left-0 right-0 flex justify-center px-6">
        <button
          type="button"
          onClick={handleEnter}
          class="flex h-[52px] w-full max-w-[360px] animate-intro-rise items-center justify-center rounded-[17px] bg-[#8e5c41] px-[10px] text-center text-[16px] font-semibold leading-5 text-white opacity-0 transition-transform duration-100 active:scale-[0.98] active:bg-[#724631]"
          style={{
            'animation-delay': `${600 + INTRO_LIST_ITEM_COUNT * 200 + 100}ms`,
          }}
        >
          {m.btn_enter()}
        </button>
      </div>
    </main>
  )
}
